'use strict';

import { submitForm, submitFormEsubscriber } from "./commons/commonForms";
import { readCookie } from "./commons/cookies";
import { searchUrlParam } from "./commons/utm";
import { startFooterScript } from "./register-forms/footer/footer";
import { fromForms } from "./register-forms/formsEnum";
import { initSelectIndustrias } from "./register-forms/select-industrias";


const addFormListeners = () => {
  document.addEventListener('DOMContentLoaded', () => {


    const formSubscribe = document.getElementById('form-subscribe');
    const formCaptador = document.getElementById('form-captador');
    const formResources = document.querySelectorAll('.download-resource');
    const resourcesImages = document.querySelectorAll('figure .show-image-download');

    const indusrtySelectElements = document.querySelectorAll(".select-industry");
    indusrtySelectElements.forEach(selectElement => {
      initSelectIndustrias(selectElement, document.documentElement.lang);
    });

    if (formSubscribe) {
      startFooterScript();
    }
    if (formCaptador) {
      formCaptador.querySelector('.submitButton').addEventListener('click', (e) => {
        submitForm(e, formCaptador, fromForms.captador).then(() => {
          // Simula delay hasta que se resuelva el problema de babel para poder usar async y await
          formCaptador.classList.add('success');
          setTimeout(() => {
            document.getElementById('captador').style.display = 'none';
          }, 6000);
        })
      }
      );
    }
    if (formResources) {
      formResources.forEach(formResource => {
        formResource.querySelector('div .loader .submitButton').addEventListener('click', (e) => {
          submitForm(e, formResource, fromForms.resources).then(() => {
            formResource.closest('figure').classList.add('downloading');
            document.querySelector('figure.open').classList.remove('open');

            setTimeout(() => {
              formResource.querySelector('a.action-link').click();;
              formResource.closest('figure').classList.remove('downloading');
            }, 2000);
          })
        }
        );
      });

      resourcesImages.forEach(resourseImage => {
        resourseImage.addEventListener('click', (e) => {


          e.preventDefault();
          const hash = resourseImage.hash;
          const dataHref = resourseImage.getAttribute('data-href');

          if (hash !== '') {
            const targetElement = document.querySelector(hash);
            const height = targetElement.offsetTop - 74;
            location.hash = hash;
            if (document.location.hash === hash) {
              e.preventDefault();
              window.scrollTo(0, height);
            }
          }

          if (!!readCookie('esubscriber')) {
            const form = resourseImage.parentNode.querySelector('form');
            const action = form.querySelector('a.action-link');

            submitFormEsubscriber(e, form, fromForms.resources).then(() => {
              form.closest('figure').classList.add('downloading');
              document.querySelector('figure.open').classList.remove('open');

              setTimeout(() => {
                action.click();
                form.closest('figure').classList.remove('downloading');
              }, 2000);

              if (dataHref !== '#') {
                resourseImage.setAttribute('href', dataHref);
                action.click();
                resourseImage.removeAttribute('href');
              } else {
                action.click();
              }

            })
          } else {
            const email = searchUrlParam('email');
            const figure = resourseImage.closest('figure');
            const emailInput = figure.querySelector('input[type=email]');

            const openFigures = document.querySelectorAll('figure.open');
            openFigures.forEach((openFigure) => {
              openFigure.classList.remove('open');
            });

            emailInput.value = email;
            figure.classList.add('open');
          }
        });

      });
    }
  });
}
addFormListeners();
